export const ADMIN_SYSTEM_ID = '01998427-994f-7de3-8741-d73bed2e4ae4';
